export default {
  name: "Resource_OverridePlease",
  components: {},
  props: {
    resource: {
      type: Object,
      required: false,
      default: () => {}
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    },
    userData: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplayActivity: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplaySettings: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  methods: {
    handleSetUp() {
      //Use Mixins
      this.$emit("app-setup", this.appSetUp);
    },
    handleRefreshResource() {
      //console.log('refreshing resource');
      this.$emit("refresh-publishing");
    },
    showResource() {
      this.show = true;
    },
    appLog(data) {
      //Use Mixins
      this.$emit("appLog", data);
    },
    handleUserClickedAbout() {
      //Use Mixins
      debugger;
      if ( this.$refs[this.resourceBaseRef] &&
          this.$refs[this.resourceBaseRef].hasOwnProperty(`handleOpenAboutIntroClick`)) {
        this.$refs[this.resourceBaseRef].handleOpenAboutIntroClick();
      }
    },
    handleSettingsUserChange(settingsForUser) {
      //can be a mixin
      const payload = {
        settingsForUser: settingsForUser,
        toolId: this.resource.toolId
      };
      this.$store.dispatch("tools/setSettingsUserForTool", payload);
    },
    handleSettingsGenChange(settings) {
      //move to mixin
      this.$emit("settings-gen-changed", settings);
    },
    handleUpdateSettings() {
      //can be a mixin
      this.$emit("update-settings"); //Resource BlockIndex
    },
    handleUpdateUserData(userDataPayload) {
      this.$emit("update-user-data", userDataPayload);
    }
  },
  data() {
    return {
      resourceBaseRef:'resource-base-id',
      appSetUp: {
        useStyleClass: false,
        bgImgURL: "https://mdbcdn.b-cdn.net/img/new/fluid/nature/011.webp"
      },
      show: false,
      title: this.resource.name,
      imgURL: this.resource.imgURL,
      faIcon: this.resource.icon ? this.resource.icon : "fa-folder"
    };
  }
};
